'use strict';

/**
 * Show a spinner inside a given element
 * @param {element} $target - Element to block by the veil and spinner.
 *                            Pass body to block the whole page.
 */
function addSpinner($target) {
    var $veil = $('<div class="veil"><div class="underlay"></div></div>');
    var ua = window.navigator.userAgent;
    if (ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1 || ua.indexOf('Edge/') > -1) {
        $veil.append('<div class="spinner"><div class="dot1"></div><div class="dot2"></div></div>');
    } else {
        $veil.append('<div class="loader-animation"><svg><g class="columbia-group__one"><rect x="0" y="0" rx="6" ry="6" width="18" height="40" /><rect x="22" y="0" rx="6" ry="6" width="18" height="40" /></g><g class="columbia-group__two"><rect x="45" y="0" rx="6" ry="6" width="40" height="18" /><rect x="45" y="22" rx="6" ry="6" width="40" height="18" /></g><g class="columbia-group__four"><rect x="0" y="45" rx="6" ry="6" width="40" height="18" /><rect x="0" y="67" rx="6" ry="6" width="40" height="18" /></g><g class="columbia-group__three"><rect x="45" y="45" rx="6" ry="6" width="18" height="40" /><rect x="67" y="45" rx="6" ry="6" width="18" height="40" /></g></svg></div>');
    }
    if ($target.get(0).tagName === 'IMG') {
        $target.after($veil);
        $veil.css({ width: $target.width(), height: $target.height() });
        if ($target.parent().css('position') === 'static') {
            $target.parent().css('position', 'relative');
        }
    } else {
        $target.append($veil);
        if ($target.css('position') === 'static') {
            $target.parent().css('position', 'relative');
            $target.parent().addClass('veiled');
        }
        if ($target.get(0).tagName === 'BODY') {
            $veil.css('position', 'fixed');
            $veil.find('.spinner').css('position', 'fixed');
        }
    }
    $veil.click(function (e) {
        e.stopPropagation();
    });
}

/**
 * Remove existing spinner
 * @param  {element} $veil - jQuery pointer to the veil element
 */
function removeSpinner($veil) {
    if ($veil.parent().hasClass('veiled')) {
        $veil.parent().css('position', '');
        $veil.parent().removeClass('veiled');
    }
    $veil.off('click');
    $veil.remove();
}

// element level spinner:
$.fn.spinner = function () {
    var $element = $(this);
    var Fn = function () {
        this.start = function () {
            if ($element.length) {
                addSpinner($element);
            }
        };
        this.stop = function () {
            if ($element.length) {
                var $veil = $('.veil');
                removeSpinner($veil);
            }
        };
    };
    return new Fn();
};

// page-level spinner:
$.spinner = function () {
    var Fn = function () {
        this.start = function () {
            addSpinner($('body'));
        };
        this.stop = function () {
            removeSpinner($('.veil'));
        };
    };
    return new Fn();
};
